import React from "react";
import { Row, Tooltip } from "antd";
import { WarningOutlined } from "@ant-design/icons";

export function ContentWithWarnings({ content, warnings }) {
  if (!warnings?.length) return content;
  return (
    <Row justify="space-between" align="middle" wrap={false}>
      <span style={{ flex: 1, minWidth: 0 }}>{content}</span>
      <Tooltip
        title={
          warnings.length === 1
            ? warnings[0]
            : warnings.map((m, i) => (
                <div key={i}>
                  {i + 1}. {m}
                </div>
              ))
        }
      >
        <span style={{ marginLeft: 8 }}>
          <WarningOutlined style={{ color: "red" }} />
        </span>
      </Tooltip>
    </Row>
  );
}
